import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { RiskCategoryFilters } from '../../../commons/models/risk-category.model';

@Component({
  selector: 'app-risk-category-filters',
  templateUrl: './risk-category-filters.component.html',
  styleUrls: ['./risk-category-filters.component.scss']
})
export class RiskCategoryFiltersComponent {


  @Output()
  onFilter: EventEmitter<RiskCategoryFilters> = new EventEmitter();

  private _defaultFilters: RiskCategoryFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getRiskCategoryFilters());
  }

  private _getRiskCategoryFilters(): RiskCategoryFilters {
    let filters: RiskCategoryFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): RiskCategoryFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: RiskCategoryFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
        })
      }
    }
  }
}
